function initializeMainSlider() {
  const mainSliderElements = document.querySelectorAll(".main-slider");
  let interleaveOffset = 0.2;

  mainSliderElements.forEach(function (sliderElement) {
    const enableAutoplay = sliderElement.dataset.enableAutoplay === "true";
    const autoplaySpeedSeconds =
      parseFloat(sliderElement.dataset.autoplaySpeed) || 3;
    const autoplaySpeedMilliseconds = autoplaySpeedSeconds * 1000;
    const sliderDirection = sliderElement.dataset.sliderDirection;
    const sliderAxis = sliderElement.dataset.sliderAxis;
    const sliderLoop = sliderElement.dataset.sliderLoop==="true";

     if (sliderDirection === "vertical") {
      interleaveOffset = 0.2; 
    } else {
      interleaveOffset = 0.5; 
    }

    const mainSliderOptions = {
      loop: sliderLoop,
      speed: 1000,
      direction: sliderDirection,
      loopAdditionalSlides: 10,
      grabCursor: true,
      watchSlidesProgress: true,
      autoplay: enableAutoplay ? { delay: autoplaySpeedMilliseconds } : false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
      on: {
        init: function () {
          this.autoplay.stop();
        },
        slideChangeTransitionEnd: function () {
          let swiper = this,
            captions = swiper.el.querySelectorAll(".caption, .banner-buttons");
          for (let i = 0; i < captions.length; ++i) {
            captions[i].classList.remove("show");
          }
          let activeSlide = swiper.slides[swiper.activeIndex];

          let caption = activeSlide.querySelector(".caption");
          if (caption) {
              caption.classList.add("show");
            }

          let bannerButtons = activeSlide.querySelector(".banner-buttons");
          if (bannerButtons) {
              bannerButtons.classList.add("show");
            }         
        },
        progress: function () {
          let swiper = this;
          for (let i = 0; i < swiper.slides.length; i++) {
            let slideProgress = swiper.slides[i].progress,
              innerOffset = swiper.width * interleaveOffset,
              innerTranslate = slideProgress * innerOffset;

            var slideElement = swiper.slides[i].querySelector(".slide-bgimg");
            if (sliderDirection === "vertical") {
              slideElement.style.transform =
                "translateY(" + innerTranslate + "px)";
            } else {
              slideElement.style.transform =
                "translateX(" + innerTranslate + "px)";
            }
          }
        },
        touchStart: function () {
          let swiper = this;
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = "";
          }
        },
        setTransition: function (speed) {
          let swiper = this;
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = speed + "ms";
            swiper.slides[i].querySelector(".slide-bgimg").style.transition =
              speed + "ms";
          }
        },
      },
    };

    new Swiper(sliderElement, mainSliderOptions);
  });
}
